export const SET_LOGIN_PENDING = 'pzh.auth.SET_LOGIN_PENDING';
export const SET_LOGIN_SUCCESS = 'pzh.auth.SET_LOGIN_SUCCESS';
export const SET_LOGIN_ERROR = 'pzh.auth.SET_LOGIN_ERROR';
export const SET_AUTHENTICATION_ERROR = 'pzh.auth.SET_AUTHENTICATION_ERROR';

export const setAuthenticationError = (error) => ({
    type: SET_AUTHENTICATION_ERROR,
    error,
});
